import { css } from 'aphrodite';
import * as React from 'react';
import { mobileStyles } from '../styles';

interface MobileContentEditorProps {
	content: string;
	onContentChange: (content: string) => void;
	placeholder?: string;
	readOnly?: boolean;
	maxLength?: number;
}

const MobileContentEditor: React.FC<MobileContentEditorProps> = ({
	content,
	onContentChange,
	placeholder = "What's on your mind?",
	readOnly = false,
	maxLength = 2200,
}) => {
	const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		if (readOnly) return;
		onContentChange(e.target.value);
	};

	const remainingChars = maxLength - content.length;

	return (
		<div className={css(mobileStyles.contentEditorContainer)}>
			<div className={css(mobileStyles.contentEditorHeader)}>
				<div className={css(mobileStyles.contentEditorLabel)}>Content</div>
				<div
					className={css(
						mobileStyles.contentEditorCharCount,
						remainingChars < 0 && mobileStyles.contentEditorCharCountError
					)}
				>
					{content.length > 0 ? `${content.length}/${maxLength}` : `${maxLength}`}
				</div>
			</div>
			<div className={css(mobileStyles.contentEditorTextAreaContainer)}>
				<textarea
					className={css(mobileStyles.contentEditorTextArea, readOnly && mobileStyles.contentEditorTextAreaReadOnly)}
					value={content}
					onChange={handleChange}
					placeholder={placeholder}
					disabled={readOnly}
					maxLength={maxLength}
					rows={4}
				/>
			</div>
		</div>
	);
};

export { MobileContentEditor };
